import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  CrossPlatformLocationIcon,
  ReactIcon,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android App Development",
    description: (
      <>
        We've revolutionized our{" "}
        <Link
          to="/android-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          Android app development service
        </Link>{" "}
        in Miami based on an efficient and streamlined development process. Our
        approach is designed to optimize every stage of your app's creation,
        from concept to deployment. With our team of skilled developers
        efficient in coding and development, we leverage the latest Android
        technologies. Further, you will have regular updates and flexibility
        throughout the development procedure.
      </>
    ),
  },
  {
    icon: IphoneIcon,
    title: "Iphone App Development",
    description: (
      <>
        We unlock the boundless potential of the iOS ecosystem with our
        tailor-made{" "}
        <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
          iPhone app development services
        </Link>{" "}
        in Miami. If you're seeking a customer-centric app to extend your
        brand's scale while enhancing operational efficiency, we can help you
        with our proficient app development. Our expert app developers in Miami
        ensure to build a robust application with high performance based on a
        seamless UI.
      </>
    ),
  },
  {
    icon: GameIcon,
    title: "Game App Development",
    description: (
      <>
        Our{" "}
        <Link to="/game-development" rel="noopener" aria-label="TekRevol">
          game app development service
        </Link>{" "}
        in Miami revolves around a dynamic development process. Our dedicated
        team of developers, skilled with the latest game development
        technologies and tools, creates compelling gaming experiences. Whether
        you need 2D or 3D, mobile or console, our expertise in Unity, Unreal
        Engine, and other industry-leading tools ensures your game's engaging
        graphics and seamless gameplay.
      </>
    ),
  },
  {
    icon: FlutterIcon,
    title: "Flutter App Development",
    description: (
      <>
        We create cross-platform apps with stunning visuals and responsive
        performance based on our{" "}
        <Link
          to="/flutter-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          Flutter app development service.
        </Link>{" "}
        Our experienced developers streamline the development process, saving
        you time and resources by targeting both iOS and Android with a single
        codebase. Utilizing Flutter's rich library of pre-built widgets, we
        build rich-featured apps for multiple platforms with a reliable user
        experience.
      </>
    ),
  },
  {
    icon: CrossPlatformLocationIcon,
    title: "Cross-Platform App Development",
    description:
      "Our cross-platform app development service helps your app reach a wider audience by maintaining its presence on both iOS and Android platforms. We deliver a high-performance and user-centric experience based on advanced frameworks like React Native and Flutter. You can leverage our expert resources to create maximum impact with our efficient cross-platform solutions as per your business needs.",
  },
  {
    icon: ReactIcon,
    title: "React Native App Development",
    description:
      "Leveraging React Native, our professional developers in Miami can build native experience apps while providing cost and time-saving benefits. Our React Native app development services offer a compelling fusion of cross-platform efficiency and native app performance. We specialize in delivering streamlined, user-friendly applications customized to meet your specific business requirements and user expectations.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2> Our Robust Application Development Services in Miami</h2>
            <p className="impro_para">
              At TekRevol, we are acutely aware that innovation thrives when
              guided by experts. Leveraging our profound expertise in both
              technology and business, we facilitate our clients by optimizing
              their business operations through workflow streamlining. Our
              services encompass process automation, system integration, and
              harnessing data insights. As the leading app developers in Miami,
              here is what we offer to our clients:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={10} className="m-auto">
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
